import React, { ComponentProps, FC } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { BoxV2 as Box, Flex } from 'portal-commons';

import { remapTCRStatus } from '../../utils';
import { getStatusIcon } from '@/utils/statusIcon';
import { ROUTES } from '@/constants/paths';
import { convertTimeWithTimezone, US_DATE_FORMAT } from '@/utils/time';
import { CampaignListItem } from '@/apis/core';

interface RcsCampaignListingRowProps {
  campaign: CampaignListItem;
}

const Cell: FC<ComponentProps<typeof TableCell>> = ({
  children,
  style,
  ...restProps
}) => {
  return (
    <TableCell style={{ overflowWrap: 'break-word', ...style }} {...restProps}>
      {children || 'N/A'}
    </TableCell>
  );
};

const RcsCampaignListingRow: FC<RcsCampaignListingRowProps> = ({
  campaign,
}) => {
  const history = useHistory();
  const location = useLocation();
  return (
    <TableRow
      data-testid="rcsCampaignsListingRow"
      onClick={() =>
        history.push({
          pathname: `${ROUTES.RCS_CAMPAIGNS}/${campaign.uid}`,
          state: {
            goBackPage: `${location.pathname}${
              location.search ? location.search : ''
            }`,
          },
        })
      }
    >
      <Cell data-testid="rcsCampaignsListingRowUid">
        <span>{campaign.uid}</span>
      </Cell>
      <Cell
        data-testid="rcsCampaignsListingRowGoogleAgentId"
        style={{
          maxWidth: 125,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {campaign.googleAgentId}
      </Cell>
      <Cell data-testid="rcsCampaignsListingRowBrandUid">
        {campaign.brandUid}
      </Cell>
      <Cell
        style={{
          maxWidth: 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        data-testid="rcsCampaignsListingRowBrandName"
      >
        {campaign.brandName}
      </Cell>
      <Cell data-testid="rcsCampaignsListingRowCspName">
        {campaign.cspName || '--'}
      </Cell>
      <Cell data-testid="rcsCampaignsListingRowDcaName">
        {campaign.mnoDcaName || 'No DCA'}
      </Cell>
      <Cell
        style={{
          maxWidth: 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        data-testid="rcsCampaignsListingRowUsecase"
      >
        {campaign.usecase}
      </Cell>
      <Cell data-testid="rcsCampaignsListingBillingCategory">
        {campaign.billingCategory}
      </Cell>
      <Cell data-testid="rcsCampaignsListingRowCreateDate">
        {convertTimeWithTimezone(
          campaign.createDate,
          undefined,
          US_DATE_FORMAT
        )}
      </Cell>
      <Cell data-testid="rcsCampaignsListingRowStatus">
        {remapTCRStatus(campaign.status)}
      </Cell>
      <Cell
        data-testid="rcsCampaignsListingRowMnoStatus"
        style={{ paddingTop: 0, paddingBottom: 0 }}
      >
        {campaign.mnoStatus && (
          <Flex>
            <Box mr="xs">
              {getStatusIcon(campaign.mnoStatus.toLowerCase(), 'RCS')}
            </Box>
            <span>{campaign.mnoStatus}</span>
          </Flex>
        )}
      </Cell>
    </TableRow>
  );
};

export default RcsCampaignListingRow;
